import { Stack } from '@chakra-ui/react';

import { FCWithChildren } from 'common/types';
import Text from 'components/_core/Text';

interface SectionProps {
  title: string;
}

const Section: FCWithChildren<SectionProps> = ({ children, title }) => (
  <Stack spacing="space-16">
    <Text fontWeight="weight-500" size="lg" variant="primary">
      {title}
    </Text>

    {children}
  </Stack>
);

export default Section;
